import React from 'react';
import AdminManagePoolAccounts from './admin-manage-pool-accounts';
import AdminManageFumos from './admin-manage-fumos';
import AdminManageSpocs from './admin-manage-spocs';
import AdminManageProxyAccess from './admin-manage-proxy-access';
import AdminManageValidationRules from './admin-manage-validation-rules';
import Accordion from '../../components/accordion/accordion';
import './admin-manage-settings.scss';

const AdminManageSettings = () => {
  const accordionSections = [
    {
      title: 'Pool Accounts',
      content: <AdminManagePoolAccounts />,
    },
    {
      title: 'FUMOs',
      content: <AdminManageFumos />,
    },
    {
      title: 'SPOCs',
      content: <AdminManageSpocs />,
    },
    {
      title: 'Proxy Access',
      content: <AdminManageProxyAccess />,
    },
    {
      title: 'Validation Rules',
      content: <AdminManageValidationRules />,
    },
  ];

  return (
    <div className="admin-manage-settings">
      <Accordion sections={accordionSections} />
    </div>
  );
};

export default AdminManageSettings;
